import CryptoJS from "crypto-js";
export default{

    // 解密函数
    wordDecrypt(word) {
        word = decodeURIComponent(word);
        let key = CryptoJS.enc.Utf8.parse("ghgfkjyertwewjvb");
        let iv = CryptoJS.enc.Utf8.parse("uouyerqwcczhdfel");
        var decrypted = CryptoJS.AES.decrypt(word, key, {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });
        return decrypted.toString(CryptoJS.enc.Utf8);
    },


    // 加密函数
    wordEncrypt(word) {
        let key = CryptoJS.enc.Utf8.parse("ghgfkjyertwewjvb");
        let iv = CryptoJS.enc.Utf8.parse("uouyerqwcczhdfel");
        let encrypted = "";
        if (typeof word == "string") {
            let srcs = CryptoJS.enc.Utf8.parse(word);
            encrypted = CryptoJS.AES.encrypt(srcs, key, {
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
            });
        } else if (typeof word == "object") {
            //对象格式的转成json字符串
            let data = JSON.stringify(word);
            let srcs = CryptoJS.enc.Utf8.parse(data);
            encrypted = CryptoJS.AES.encrypt(srcs, key, {
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
            });
        }
        return encodeURIComponent(CryptoJS.enc.Base64.stringify(encrypted.ciphertext));
    }
}


// WEBPACK FOOTER //
// ./src/utils/crypto.js